import React from "react";
import { getClassNameFactory } from "../../../../utilities";
import NavList from "../NavList";

var Footer = function Footer(_ref) {
  var children = _ref.children,
      logoHref = _ref.logoHref,
      _ref$isExpanded = _ref.isExpanded,
      isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded,
      _ref$handleItemClick = _ref.handleItemClick,
      _handleItemClick = _ref$handleItemClick === void 0 ? function () {} : _ref$handleItemClick;

  var getClassName = getClassNameFactory(Footer.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "inner"
    })
  }, /*#__PURE__*/React.createElement("a", {
    href: logoHref
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "logo"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "logoInner"
    })
  }))), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "listContainer"
    })
  }, /*#__PURE__*/React.createElement("ul", {
    className: getClassName({
      descendantName: "list-desktopShow"
    })
  }, children), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "list-mobileShow"
    })
  }, /*#__PURE__*/React.createElement(NavList, {
    title: /*#__PURE__*/React.createElement("div", {
      className: getClassName({
        descendantName: "logoInner"
      })
    }),
    isExpanded: isExpanded,
    handleItemClick: function handleItemClick() {
      return _handleItemClick === null || _handleItemClick === void 0 ? void 0 : _handleItemClick("logo");
    }
  }, children)))));
};

Footer.displayName = "SiteFooter.Footer";
export default Footer;